export default __webpack_public_path__ + "emergency-fund.png";